document.addEventListener('DOMContentLoaded', function () {
    // Variable product radio button on product detail page
    document.addEventListener('change', function (event) {
        if (event.target.classList.contains('variation-radios') && event.target.tagName === 'INPUT') {
            var checkedInputs = document.querySelectorAll('.variation-radios input:checked');
            checkedInputs.forEach(function (input) {
                var thisName = input.getAttribute('name');
                var thisVal = input.value;
                var selectElement = document.querySelector('select[name="' + thisName + '"]');
                if (selectElement) {
                    selectElement.value = thisVal;
                    selectElement.dispatchEvent(new Event('change'));
                }
            });
        }
    });

    document.addEventListener('woocommerce_update_variation_values', function () {
        var variationInputs = document.querySelectorAll('.variation-radios input');
        variationInputs.forEach(function (input) {
            var thisName = input.getAttribute('name');
            var thisVal = input.value;
            input.removeAttribute('disabled');
            var selectOption = document.querySelector('select[name="' + thisName + '"] option[value="' + thisVal + '"]');
            if (selectOption && selectOption.disabled) {
                input.disabled = true;
            }
        });
    });
});